import qs from 'qs';
import helpers from './helpers';

const driver = {
  // Not meant to be a query-able endpoint
  search(query) {
    return helpers.request(`drivers?${qs.stringify(query)}`, helpers.requestOptions('GET'));
  },
};

export default driver;
